import { CustomFieldValue } from '@xiag-search/sdk';

export function getCustomFieldNumber(value: CustomFieldValue | null): number | null {
    if (typeof value !== 'string') {
        return null;
    }

    const integer = parseInt(value, 10);
    return isNaN(integer) ? null : integer;
}
